<template>
  <div id="app">
    <router-view />
    <error-notification></error-notification>
  </div>
</template>

<script>
import appConfig from "@/app.config";
import ErrorNotification from '@/components/admin/ErrorNotification.vue';

export default {
  name: "app",
  components: {
    ErrorNotification,
  },
  page: {
    // All subcomponent titles will be injected into this template.
    titleTemplate(title) {
      title = typeof title === "function" ? title(this.$store) : title;
      return title ? `${title} | ${appConfig.title}` : appConfig.title;
    }
  }
};
</script>